import { IUseCompanyProfileContext } from '@helper/react-context/context-hooks/use-company-profile-context';
import { Context } from '@helper/react-context/context-provider';
import { useContext } from 'react';

// Hook for easier use of the specific context without the need to call useContext() and import the global Context itself.
const useCompanyProfile = (): IUseCompanyProfileContext => useContext(Context).companyProfile;

export default useCompanyProfile;
